const ApiExceptionCode = {
    VALIDATION_FAILED: 'VALIDATION_FAILED',
    GENERAL_ERROR: 'GENERAL_ERROR',
    INVALID_PARAMETER: 'INVALID_PARAMETER',
    EXTERNAL_SERVER_ERROR: 'EXTERNAL_SERVER_ERROR', // 외부 서버 오류 애러로 처리하는 경우
    EXTERNAL_SERVER_WARNING: 'EXTERNAL_SERVER_WARNING', // 외부 서버 오류 경고로 처리하는 경우
    UNSUPPORTED_ENUM_CODE: 'UNSUPPORTED_ENUM_CODE',
    BUSINESS_INVALID: 'BUSINESS_INVALID',
    RULE_VIOLATION: 'RULE_VIOLATION',
    MESSAGE_ENCRYPTION_FAILED: 'MESSAGE_ENCRYPTION_FAILED',
    KAFKA_CONSUMER_NOT_RETRYABLE: 'KAFKA_CONSUMER_NOT_RETRYABLE',
    KAFKA_CONSUMER_NOT_RECOVERABLE: 'KAFKA_CONSUMER_NOT_RECOVERABLE',

    MEMBER_NOT_FOUND: 'MEMBER_NOT_FOUND',
    DUPLICATE_PHONE_USER_NOT_FOUND: 'DUPLICATE_PHONE_USER_NOT_FOUND',
    ORDER_NOT_FOUND: 'ORDER_NOT_FOUND',
    ORDER_ALREADY_PERSISTED: 'ORDER_ALREADY_PERSISTED',
    QUICK_JOIN_MEMBERSHIP_FAILED_UNCATEGORIZED_ERROR: 'QUICK_JOIN_MEMBERSHIP_FAILED_UNCATEGORIZED_ERROR',
    QUICK_JOIN_MEMBERSHIP_FAILED_ALREADY_SUBSCRIBED: 'QUICK_JOIN_MEMBERSHIP_FAILED_ALREADY_SUBSCRIBED',
    QUICK_JOIN_MEMBERSHIP_FAILED_ALREADY_SUBSCRIBED_WITH_NAVER_ID:
        'QUICK_JOIN_MEMBERSHIP_FAILED_ALREADY_SUBSCRIBED_WITH_NAVER_ID',
    QUICK_JOIN_MEMBERSHIP_FAILED_RESUBSCRIBE_ON_THE_SAME_DAY:
        'QUICK_JOIN_MEMBERSHIP_FAILED_RESUBSCRIBE_ON_THE_SAME_DAY',
    URL_HMAC_ENCRYPTION_FAILED: 'URL_HMAC_ENCRYPTION_FAILED',
    DELIVERY_ADDRESS_NOT_AGREED: 'DELIVERY_ADDRESS_NOT_AGREED',
    /** 정기구독에 설정된 배송지로 삭제할 수 없습니다. */
    DELIVERY_ADDRESS_FOR_SUBSCRIPTION: 'DELIVERY_ADDRESS_FOR_SUBSCRIPTION',
    /** 이미 삭제된 배송지 입니다. */
    REMOVE_DELIVERY_ADDRESS_FAILED_ALREADY_REMOVED: 'REMOVE_DELIVERY_ADDRESS_FAILED_ALREADY_REMOVED',
    AVAILABLE_CARD_NOT_EXISTS: 'AVAILABLE_CARD_NOT_EXISTS',
    ENTER_TICKET_NOT_FOUND: 'ENTER_TICKET_NOT_FOUND',
    INVALID_COUPON_PUBLICATION: 'INVALID_COUPON_PUBLICATION',
    API_EASYBOOKING_OUT_OF_STOCK: 'API_EASYBOOKING_OUT_OF_STOCK',
    API_EASYBOOKING_CHECK_STOCK_FAILED: 'API_EASYBOOKING_CHECK_STOCK_FAILED',
    GET_PURCHASER_COMMISSIONS_FAILED: 'GET_PURCHASER_COMMISSIONS_FAILED',
    // 페이머니 회원조회 실패
    GET_CHARGE_POINT_USER_FAILED: 'GET_CHARGE_POINT_USER_FAILED',
    GET_RECHARGEABLE_AMOUNT_FAILED: 'GET_RECHARGEABLE_AMOUNT_FAILED',
    GET_CHARGE_POINT_FAILED_REQUEST_EXCEEDED: 'GET_CHARGE_POINT_FAILED_REQUEST_EXCEEDED',
    MERCHANT_NOT_FOUND: 'MERCHANT_NOT_FOUND',
    MERCHANT_NO_NOT_FOUND: 'MERCHANT_NO_NOT_FOUND',
    /** 친구 선택 정보가 없습니다. */
    GET_GIFTING_FRIENDS_SESSION_FAILED: 'GET_GIFTING_FRIENDS_SESSION_FAILED',
    GET_GIFTING_PLAYER_IDS_FAILED: 'GET_GIFTING_PLAYER_IDS_FAILED',
    /** 현재 알비백 보증금 금액 조회 오류로 주문이 불가합니다. 잠시 후 다시 시도해 주세요. */
    GET_SSG_DEPOSIT_FAILED: 'GET_SSG_DEPOSIT_FAILED',
    SELLER_MERCHANT_NO_NOT_FOUND: 'SELLER_MERCHANT_NO_NOT_FOUND',
    GET_PURCHASE_COUNT_FAILED: 'GET_PURCHASE_COUNT_FAILED',
    APPROVE_PAY_NEXT_PAYMENT_FAIL: 'APPROVE_PAY_NEXT_PAYMENT_FAIL',
    GET_DELIVERY_SLOT_FAIL: 'GET_DELIVERY_SLOT_FAIL',
    // 적립포인트 정책 실패
    GET_REWARD_POLICY_FAILED: 'GET_REWARD_POLICY_FAILED',
    SELLER_MERCHANT_ADDRESS_BOOK_NOT_FOUND: 'SELLER_MERCHANT_ADDRESS_BOOK_NOT_FOUND',
    SELLER_MERCHANT_NOT_FOUND: 'SELLER_MERCHANT_NOT_FOUND',
    /** 일시적인 장애로 안심번호 이용신청이 실패되었습니다. 잠시 후에 다시 시도해 주세요. */
    ISSUE_VIRTUAL_PHONE_NUMBER_FAILED: 'ISSUE_VIRTUAL_PHONE_NUMBER_FAILED',
    /** 안심번호 발급이 불가한 전화번호 입니다. 확인 후 다시 요청 부탁드립니다. */
    INVALID_PHONE_NUMBER_FOR_ISSUING_VIRTUAL_PHONE_NUMBER: 'INVALID_PHONE_NUMBER_FOR_ISSUING_VIRTUAL_PHONE_NUMBER',
    DIRECT_ORDER_PAY_METHOD_NOT_FOUND: 'DIRECT_ORDER_PAY_METHOD_NOT_FOUND',
    /** 판매회원 미가입자 */
    UNREGISTERED_SELLER: 'UNREGISTERED_SELLER',
} as const

const PaymentExceptionCode = {
    BILLING_BAD_REQUEST: 'BILLING_BAD_REQUEST',
    BILLING_MERCHANT_NOT_FOUND: 'BILLING_MERCHANT_NOT_FOUND',
    BILLING_ITEM_NOT_FOUND: 'BILLING_ITEM_NOT_FOUND',
    BILLING_PRE_APPROVE_FAIL: 'BILLING_PRE_APPROVE_FAIL',
    BILLING_PAYMENT_FAIL: 'BILLING_PAYMENT_FAIL',
    BILLING_RECHARGE_POINT_FAIL: 'BILLING_RECHARGE_POINT_FAIL',
    BILLING_POINT_FAIL: 'BILLING_POINT_FAIL',
    BILLING_SERVER_ERROR: 'BILLING_SERVER_ERROR',
    BILLING_PG_ERROR: 'BILLING_PG_ERROR',
    BILLING_ERROR: 'BILLING_ERROR',
    COUPON_APPROVE_FAIL: 'COUPON_APPROVE_FAIL',
    PERSIST_PAYMENT_FAIL: 'PERSIST_PAYMENT_FAIL',
    CASH_RECEIPT_FAIL: 'CASH_RECEIPT_FAIL',
    PAYMENT_ERROR: 'PAYMENT_ERROR',
    /** seller 용 */
    INVALID_CARD_PROMOTION: 'INVALID_CARD_PROMOTION',
    INVALID_CARD_PROMOTION_DISCOUNT_AMOUNT: 'INVALID_CARD_PROMOTION_DISCOUNT_AMOUNT',
    NOT_IMPLEMENTED: 'NOT_IMPLEMENTED',
    /** @ref https://oss.fin.navercorp.com/Product-Planning/Order_Plan/issues/1807 */
    DUPLICATE_ORDER_SHEET_ID: 'DUPLICATE_ORDER_SHEET_ID',
} as const

const MallExceptionCode = {
    VALIDATION_FAILED: 'VALIDATION_FAILED',
    MEMBER_NOT_AGREED: 'MEMBER_NOT_AGREED',
    INVALID_MEMBER_STATUS: 'INVALID_MEMBER_STATUS',
    INVALID_REGISTER_ORDER: 'INVALID_REGISTER_ORDER',
    ORDER_SHEET_NOT_FOUND: 'ORDER_SHEET_NOT_FOUND',
    ORDER_ALREADY_CREATED: 'ORDER_ALREADY_CREATED',
    ORDER_SHEET_ASSEMBLE_FAILED: 'ORDER_SHEET_ASSEMBLE_FAILED',
    GET_ADDITIONAL_DELIVERY_FEE_FAIL: 'GET_ADDITIONAL_DELIVERY_FEE_FAIL',
    ORDER_PROCESS_NOT_FOUND: 'ORDER_PROCESS_NOT_FOUND',
    APPLY_ORDER_PROCESS_TIMEOUT: 'APPLY_ORDER_PROCESS_TIMEOUT',
    /** 주문 프로세스 상태 이상. 잠시 후 다시 시도해 주십시오. */
    INVALID_ORDER_PROCESS_STATE: 'INVALID_ORDER_PROCESS_STATE',
    ORDER_PROCESS_ERROR: 'ORDER_PROCESS_ERROR',
    PERSIST_ORDER_FAILED: 'PERSIST_ORDER_FAILED',
    COMPLETE_ORDER_FAILED: 'COMPLETE_ORDER_FAILED',
} as const

const EasyBookingExceptionCode = {
    ORDER_SHEET_NOT_FOUND: 'ORDER_SHEET_NOT_FOUND',
    ORDER_ALREADY_CREATED: 'ORDER_ALREADY_CREATED',
    INVALID_MEMBER_STATUS: 'INVALID_MEMBER_STATUS',
    MEMBER_NOT_AGREED: 'MEMBER_NOT_AGREED',
    VALIDATION_FAILED: 'VALIDATION_FAILED',
    INVALID_REGISTER_ORDER: 'INVALID_REGISTER_ORDER',
    EASYBOOKING_OUT_OF_STOCK: 'EASYBOOKING_OUT_OF_STOCK', // from ApiExceptionCode.API_EASYBOOKING_OUT_OF_STOCK
    EASYBOOKING_CHECK_STOCK_FAILED: 'EASYBOOKING_CHECK_STOCK_FAILED', // from ApiExceptionCode.API_EASYBOOKING_CHECK_STOCK_FAILED
    INVALID_EASYBOOKING_CHECK_STOCK_REQUEST: 'INVALID_EASYBOOKING_CHECK_STOCK_REQUEST', // from ApiExceptionCode.API_EASYBOOKING_OUT_OF_STOCK
    CAFE_CHECK_STOCK_FAILED: 'CAFE_CHECK_STOCK_FAILED',
    BLOG_OUT_OF_STOCK: 'BLOG_OUT_OF_STOCK',
    BLOG_REDUCE_STOCK_FAILED: 'BLOG_REDUCE_STOCK_FAILED',
    ORDER_SHEET_ASSEMBLE_FAILED: 'ORDER_SHEET_ASSEMBLE_FAILED',
    /** 주문 프로세스 상태 이상. 잠시 후 다시 시도해 주십시오. */
    INVALID_ORDER_PROCESS_STATE: 'INVALID_ORDER_PROCESS_STATE',
    APPLY_ORDER_PROCESS_TIMEOUT: 'APPLY_ORDER_PROCESS_TIMEOUT',
    DIRECT_ORDER_PROCESS_TIMEOUT: 'DIRECT_ORDER_PROCESS_TIMEOUT',
    ORDER_PROCESS_NOT_FOUND: 'ORDER_PROCESS_NOT_FOUND',
    ORDER_PROCESS_ERROR: 'ORDER_PROCESS_ERROR',
    PERSIST_ORDER_FAILED: 'PERSIST_ORDER_FAILED',
    COMPLETE_ORDER_FAILED: 'COMPLETE_ORDER_FAILED',
} as const

const SellerExceptionCode = {
    VALIDATION_FAILED: 'VALIDATION_FAILED',
    INVALID_REGISTER_ORDER: 'INVALID_REGISTER_ORDER',
    ORDER_SHEET_ASSEMBLE_FAILED: 'ORDER_SHEET_ASSEMBLE_FAILED',
    ORDER_SHEET_NOT_FOUND: 'ORDER_SHEET_NOT_FOUND',
    ORDER_ALREADY_CREATED: 'ORDER_ALREADY_CREATED',
    INVALID_CARD_PROMOTION_STATE: 'INVALID_CARD_PROMOTION_STATE',
    REFLECT_CARD_PROMOTION_BAD_REQUEST: 'REFLECT_CARD_PROMOTION_BAD_REQUEST',
    REFLECT_CARD_PROMOTION_BUDGET_FAILED: 'REFLECT_CARD_PROMOTION_BUDGET_FAILED',
    /** 현재 재고 조회 오류로 결제가 불가합니다. 잠시 후 다시 주문해주세요. */
    REDUCE_STOCK_FAILED: 'REDUCE_STOCK_FAILED',
    /** 재고가 부족하여 결제가 불가합니다. */
    REDUCE_STOCK_OUT_OF_STOCK: 'REDUCE_STOCK_OUT_OF_STOCK',
    /** 할인정보가 변경되어 결제가 불가합니다. */
    REDUCE_STOCK_INVALID_MERCHANT_IMMEDIATE_DISCOUNT: 'REDUCE_STOCK_INVALID_MERCHANT_IMMEDIATE_DISCOUNT',
    REDUCE_STOCK_READ_TIMEOUT: 'REDUCE_STOCK_READ_TIMEOUT',
    ORDER_PROCESS_NOT_FOUND: 'ORDER_PROCESS_NOT_FOUND',
    ORDER_PROCESS_ERROR: 'ORDER_PROCESS_ERROR',
    /** 주문 프로세스 상태 이상. 잠시 후 다시 시도해 주십시오. */
    INVALID_ORDER_PROCESS_STATE: 'INVALID_ORDER_PROCESS_STATE',
    SSG_DEPOSIT_QUERY_FAILED: 'SSG_DEPOSIT_QUERY_FAILED',
    /** 에디터 KEY 정보가 없습니다. */
    INVALID_GIFTING_EDITOR: 'INVALID_GIFTING_EDITOR',
    MEMBER_NOT_AGREED: 'MEMBER_NOT_AGREED',
    INVALID_MEMBER_STATUS: 'INVALID_MEMBER_STATUS',
    APPLY_ORDER_PROCESS_TIMEOUT: 'APPLY_ORDER_PROCESS_TIMEOUT',
    PERSIST_ORDER_FAILED: 'PERSIST_ORDER_FAILED',
    COMPLETE_ORDER_FAILED: 'COMPLETE_ORDER_FAILED',
    DISCOUNT_OVER_PAY_AMOUNT: 'DISCOUNT_OVER_PAY_AMOUNT',
    DISCOUNT_CONFLICT: 'DISCOUNT_CONFLICT',
    DISCOUNT_OVER_FIXED_TRADITIONAL_ALCOHOL_RATE: 'DISCOUNT_OVER_FIXED_TRADITIONAL_ALCOHOL_RATE',
    GIFTING_PLAYER_KEY_EMPTY: 'GIFTING_PLAYER_KEY_EMPTY',
    DISCOUNT_OVER_FIXED_BOOK_RATE: 'DISCOUNT_OVER_FIXED_BOOK_RATE',
} as const

export const ExceptionCode = {
    ...ApiExceptionCode,
    ...MallExceptionCode,
    ...EasyBookingExceptionCode,
    ...SellerExceptionCode,
    ...PaymentExceptionCode,
}
